var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { ConditionEvaluatorContext } from '../../context/conditionEvaluator/ConditionEvaluatorContext';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { runtime } from '../../runtime/Runtime';
import { Actor } from '../../actor/Actor';
export class TraitConditionEvaluator extends Actor {
    type = 'evaluator';
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get evaluatorEdit() {
        return new runtime.solidPackages.Edit.classes.EvaluatorEdit(this);
    }
    get evaluator_left() {
        return runtime.class.TraitConditionLeftEvaluator.fromSerialized({ parent: this });
    }
    get evaluator_right() {
        return runtime.class.TraitConditionRightEvaluator.fromSerialized({ parent: this });
    }
    get reg() {
        return this.traitCondition && this.traitCondition.reg;
    }
    get context() {
        return new ConditionEvaluatorContext(this);
    }
    get solidTraitCondition() {
        return this.traitCondition;
    }
    get conditionValue() {
        if (!this.traitCondition)
            return false;
        // STEP 1: manualResult
        if (this.context.app.appInfo.isAppInEditBuild && this.evaluatorEdit.conditionManualOverwrite.manualConditionValue !== null) {
            return this.evaluatorEdit.conditionManualOverwrite.manualConditionValue;
        }
        if (!this.reg) {
            console.log(`Achtung, kein condition registry für ${this.traitCondition.conditionKey}`);
            return false;
        }
        return this.reg.eval(this.context);
    }
    get isConditionTrue() {
        return !!this.conditionValue;
    }
    get aspectsTemplate() {
        return this.evaluatorEdit.conditionRegistryParams || {};
    }
    get persistentActor() {
        return this.traitCondition;
    }
}
__decorate([
    memoize
], TraitConditionEvaluator.prototype, "evaluatorEdit", null);
__decorate([
    memoize
], TraitConditionEvaluator.prototype, "evaluator_left", null);
__decorate([
    memoize
], TraitConditionEvaluator.prototype, "evaluator_right", null);
__decorate([
    memoize
], TraitConditionEvaluator.prototype, "context", null);
__decorate([
    computed
], TraitConditionEvaluator.prototype, "conditionValue", null);
